import moment from 'moment';
import React, { useLayoutEffect } from 'react';
import Loader from '../components/loader';
import { loadScript, waitUntil } from '../helpers/utility';
import { useAppSelector } from '../hooks/ReduxHooks';
import { FeedbackType } from './successlauncher-types';

export interface FeedbackFormProps {
  onClose: () => void;
  feedbackType: FeedbackType;
}

export default function FeedbackForm(props: FeedbackFormProps) {
  const clientId = useAppSelector<string>((state) => state.profile.client.id);
  const clientName = useAppSelector<string>((state) => state.profile.client.name);
  const clientSubscription = useAppSelector<string>((state) => state.profile.client.subscription);
  const clientCreatedDate = useAppSelector<string>((state) => state.profile.client.createdDate);

  const userId = useAppSelector<string>((state) => state.profile.user.id);
  const userEmail = useAppSelector<string>((state) => state.profile.user.email);
  const userFullName = useAppSelector<string>((state) => state.profile.user.fullName);
  const userCreatedDate = useAppSelector<string>((state) => state.profile.user.createdDate);

  let forumId = null;
  switch (props.feedbackType) {
    case 'FormsTemplates':
      forumId = 937692;
      break;
    case 'Account':
      forumId = 938487;
      break;
    case 'Workflows':
      forumId = 938379;
      break;
    case 'Reports':
      forumId = 938373;
      break;
    case 'MobleApps':
      forumId = 938493;
      break;
    case 'NotSure':
    default:
      forumId = 940735;
      break;
  }

  useLayoutEffect(() => {
    loadScript('https://goformz.uservoice.com/widget_environment/VelO8XDhPe09XJT4ah5Gkw.js', () => !!window.UserVoice, true).then(() => {
      window.UserVoice.push([
        'set',
        {
          accent_color: '#0b99c2',
          forum_id: forumId,
          strings: {
            post_suggestion_title: '',
            post_suggestion_body: ''
          }
        }
      ]);

      window.UserVoice.push([
        'identify',
        {
          email: userEmail,
          id: userId,
          name: userFullName,
          created_at: moment.utc(userCreatedDate).unix(),
          account: {
            id: clientId,
            name: clientName,
            created_at: moment.utc(clientCreatedDate).unix(),
            plan: clientSubscription
          }
        }
      ]);

      // The iframe never finishes loading if we call embed before session exists.
      // This can be reproduced by clearing the cookies or using incognito window. Doesn't happen on localhost
      waitUntil(() => !!window.UserVoice._getWidgetEnv().session).then(() => {
        window.UserVoice.push(['embed', '#uservoice-widget']);
      });
    });
  }, []);

  return (
    <div className="uservoice-wrapper">
      <Loader isLoading />
      <div id="uservoice-widget" />
    </div>
  );
}
